
import { addProductTypeApi } from "apis/product.api";
import FormController from "pages/layout/FormController";
import { memo, useMemo, } from "react";



const ProductTypeFormController = function () {


    const fieldSchema = useMemo(
        () => [
            {
                title: "Name",
                placeholder: "Enter name",
                key: "name",
                type: "text",
                required: true,
                default: "",
            },
            {
                title: "Priority",
                placeholder: "Enter priority",
                key: "priority",
                type: "number",
                required: true,
                default: "",
            },
        ],
        []
    );
    return <FormController

        routeForRedirect="/producttype/"
        title=" Product Type"
        inputFiedsSchema={fieldSchema}
        addFun={addProductTypeApi}
        getByIdFun={() => { }}
        updateFun={() => { }}

    />
};
export default memo(ProductTypeFormController);
